import {Component, OnInit, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { DtoArticleSubSalesgroup } from './models/DtoArticleSubSalesgroup';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";

@Component({
    selector: 'article-subsalesgroup',
    template: require('./article-subsalesgroup.component.html'),
    styles: [require('./article-subsalesgroup.component.css')]
})
@AutoUnsubscribe()

export class ArticleSubSalesgroupComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() parentId: number;
    @Input() dtoObject: DtoArticleSubSalesgroup;
    @Input() copyFromObject: DtoArticleSubSalesgroup;
    @Input() currentObjects: DtoArticleSubSalesgroup[];
    @Input() isNewObject: boolean;
    @Output() subgroupSaved = new EventEmitter<DtoArticleSubSalesgroup>();
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService) { }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]],
            isActive: true
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (!this.isNewObject) {
            this.fs.patchDtoToForm(this.dtoObject, this.form);
        } else {
            let newIndex = 1;
            if (this.currentObjects.length > 0)
                newIndex = Math.max.apply(Math, this.currentObjects.map(function(o){return o.index;})) + 1;

            this.dtoObject.index = newIndex;
            if (this.copyFromObject) {
                this.dtoObject.description = this.copyFromObject.description;
                this.dtoObject.isActive = this.copyFromObject.isActive;
            }
            this.fs.patchDtoToForm(this.dtoObject, this.form);
        }
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                let inUse = this.currentObjects.some(x => x.index == control.value);
                observer.next(inUse ? { indexNotAvailable: true } : null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.subgroupSaved.emit(result);
            this.closeWindow(true);
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-base/article-subsalesgroup.component.ts